export enum KeyCode {
	RETURN = 'ENTER',
	NUMPADENTER = 'NUMPADENTER',
	SPACE = 'SPACE',
	LEFT = 'ARROWLEFT',
	UP = 'ARROWUP',
	RIGHT = 'ARROWRIGHT',
	DOWN = 'ARROWDOWN',
	TAB = 'TAB',
	SHIFT = 'SHIFT',
	ESC = 'ESCAPE'
}
